import React from 'react';

interface EditBlueProps {
  width?: number;
  height?: number;
  className?: string;
}

const EditBlue: React.FC<EditBlueProps> = ({ 
  width = 16, 
  height = 16, 
  className 
}) => (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M9.19526 3.18993C9.67391 2.71128 10.3231 2.44238 11 2.44238C11.6769 2.44238 12.3261 2.71128 12.8047 3.18993C13.2834 3.66857 13.5523 4.31776 13.5523 4.99466C13.5523 5.67157 13.2834 6.32076 12.8047 6.7994L5.80474 13.7994C5.67971 13.9244 5.51014 13.9947 5.33333 13.9947H2.66667C2.29848 13.9947 2 13.6962 2 13.328V10.6613C2 10.4845 2.07024 10.3149 2.19526 10.1899L9.19526 3.18993ZM11 3.77572C10.6767 3.77572 10.3667 3.90414 10.1381 4.13274L3.33333 10.9375V12.6613H5.05719L11.8619 5.85659C12.0905 5.62799 12.219 5.31795 12.219 4.99466C12.219 4.67138 12.0905 4.36134 11.8619 4.13274C11.6333 3.90414 11.3233 3.77572 11 3.77572Z" 
        fill="#1D4ED8"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M8.5286 3.8566C8.78895 3.59625 9.21106 3.59625 9.4714 3.8566L12.1381 6.52326C12.3984 6.78361 12.3984 7.20572 12.1381 7.46607C11.8777 7.72642 11.4556 7.72642 11.1953 7.46607L8.5286 4.79941C8.26825 4.53906 8.26825 4.11695 8.5286 3.8566Z" 
        fill="#1D4ED8"
      />
    </svg>
  );

export default EditBlue;
